import React from 'react';
import PropTypes from 'prop-types';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import TextFilter from 'components/list/Filters/types/TextFilter';

const NameComponent = <TextFilter
    label='resources.accounts.fields.name'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='name'
/>;

const MembershipPoolsListFilters = (props) => {
    const filters = {
        basic: {
            name: {
                component: NameComponent,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
        },
    };

    return (
        <ResourceFilter
            { ...props }
            filters={ filters }
        />
    );
};

MembershipPoolsListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default MembershipPoolsListFilters;


// WEBPACK FOOTER //
// ./src/pages/membership-pools/list/MembershipPoolsListFilters.js